import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  users: [],
  searchUsers: [],
  user: false,
  loading: false,
  formLoading: false,
  error: false,
  success: false,
  boardMembers: [],
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/components/Users/index.js